import { render, staticRenderFns } from "./EventDetailsText.vue?vue&type=template&id=95d9266a"
import script from "./EventDetailsText.vue?vue&type=script&lang=ts"
export * from "./EventDetailsText.vue?vue&type=script&lang=ts"
import style0 from "./EventDetailsText.vue?vue&type=style&index=0&id=95d9266a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports